// extracted by mini-css-extract-plugin
var _1 = "ReactivateCTA_button__-FmcM";
var _2 = "ReactivateCTA_container__JQlD3";
var _3 = "ReactivateCTA_cta__JAcVm";
var _4 = "ReactivateCTA_desc__drL+P";
var _5 = "ReactivateCTA_icon__XFh-d fal";
var _6 = "ReactivateCTA_mobile__hx3BZ";
var _7 = "ReactivateCTA_shoppingBag__KMtyf fa-shopping-bag";
var _8 = "ReactivateCTA_title__PvNJO";
export { _1 as "button", _2 as "container", _3 as "cta", _4 as "desc", _5 as "icon", _6 as "mobile", _7 as "shoppingBag", _8 as "title" }
